document.addEventListener('alpine:init', () => {
    Alpine.store('wishlist', {

        numberOfItems: null,
        productIds: [],

        setNumberOfItems(numberOfItems) {
            this.numberOfItems = numberOfItems;
        },

        addProductIdsOnWishlist(productIds) {
            productIds.forEach(productId => this.setIsOnWishlist(productId, true));
        },

        isOnWishlist(productId) {
            return this.productIds.indexOf(productId) > -1;
        },

        setIsOnWishlist(productId, isOn) {
            if(isOn && !this.isOnWishlist(productId)) {
                this.productIds.push(productId);
            }
            if(!isOn && this.isOnWishlist(productId)) {
                this.productIds.splice(this.productIds.indexOf(productId), 1);
            }
        },

        async toggle(productId) {
            if(this.isOnWishlist(productId)) {
                await this.removeProduct(productId);
            } else {
                await this.addProduct(productId);
            }
        },

        async addProduct(productId) {

            const url = '/ws/wishlist/add'
                +'/sku/'+productId
                +'/form_key/'+window.mageFormKey;

            return fetch(url, {
                credentials: 'include'
            }).then(response => {

                if(!response.ok) {
                    throw new Error('response status '+response.status+'/'+response.statusText);
                }
                return response.json();

            }).then(data => {

                if(data.status === 'ok') {
                    this.setIsOnWishlist(productId, true);
                    this.setNumberOfItems(data.numberOfItems);
                    
                    // tracking
                    window._alq.push({
                        event: {
                            type: 'add_to_wishlist',
                            product_id: productId
                        }
                    });
                    window._uxa.push(['trackPageEvent', 'Wishlist Product Added']);
                    (window.rtbhEvents || []).push({ eventType: 'wishlist', offerId: productId }, { eventType: 'uid', id: window.rtb_house_uid });
                    if(data.adsConversion) {
                        gtag('event', 'conversion', data.adsConversion);
                    }
                    if(data.ga4EventData) {
                        gtag('event', data.ga4EventData.name, data.ga4EventData.params);
                        fbq('track', 'AddToWishlist', {
                            'content_type' : 'product',
                            'contents' : [
                                {
                                    'id' : productId,
                                    'quantity' : 1                                 
                                }
                            ],
                            'value' : data.ga4EventData.params.value,
                            'currency' : data.ga4EventData.params.currency
                        }, data.uniqueEventId ? { eventID: data.uniqueEventId } : {});
                    }
                    if(window.taboolaAccountIdConnexity) {
                        const taboolaEvent = {
                            id: window.taboolaAccountIdConnexity,
                            notify: 'ecevent',
                            name: 'ADD_TO_WISH_LIST',
                            productIds: [ productId ]
                        };
                        if(window.taboolaUnifiedId) {
                            event.unified_id = window.taboolaUnifiedId; 
                        }
                        window._tfa.push(taboolaEvent);
                    }
                }

            }).catch(error => {
                _global_console.log(error);
            })
        },

        async removeProduct(productId) {

            const url = '/ws/wishlist/remove'
                +'/sku/'+productId
                +'/form_key/'+window.mageFormKey;

            return fetch(url, {
                credentials: 'include'
            }).then(response => {

                if(!response.ok) {
                    throw new Error('response status '+response.status+'/'+response.statusText);
                }
                return response.json();

            }).then(data => {

                if(data.status === 'ok') {
                    this.setIsOnWishlist(productId, false);
                    this.setNumberOfItems(data.numberOfItems);
                }

            }).catch(error => {

                _global_console.log(error);
            })
        }
    });    
    Alpine.data('addToWishlist', (productId) => ({
        isOn: false,
        init() {
            Alpine.effect(() => {
                this.isOn = Alpine.store('wishlist').isOnWishlist(productId);
            });
        },
        toggle() {
            Alpine.store('wishlist').toggle(productId);
        }
    }));
});